(()=>{
  function initFocus(){
    const root=document.querySelector('[data-hfd]');
    if(!root||root.dataset.focusReady)return;
    root.dataset.focusReady='1';

    const style=document.createElement('style');
    style.textContent=`
      [data-hfd] .hfd__select-row{grid-template-columns:92px minmax(100px,.72fr) minmax(145px,1.28fr) 42px!important;grid-template-rows:44px auto}
      [data-hfd] .hfd__focus-cell{grid-column:4;grid-row:1;height:44px;display:flex;align-items:center;justify-content:center;border-left:1px solid #e4eaf0;background:#fff}
      [data-hfd] .hfd__focus-cell[hidden]{display:none!important}
      [data-hfd] .hfd__focus-button{width:31px;height:31px;border:1px solid #ccd8e5;border-radius:6px;background:#f8fbff;color:#5d6f84;display:flex;align-items:center;justify-content:center;padding:0;cursor:pointer}
      [data-hfd] .hfd__focus-button:hover{border-color:#087df5;color:#087df5;background:#eef6ff}
      [data-hfd] .hfd__focus-button svg{width:21px;height:21px;display:block}
      [data-hfd] .hfd__type-select,[data-hfd] [data-selection-type]{grid-column:2;grid-row:1}
      [data-hfd] .hfd__search-select,[data-hfd] [data-flag-selection],[data-hfd] .hfd__upload-controls{grid-column:3;grid-row:1}
      [data-hfd] .hfd__image-adjustments{grid-column:1/-1;grid-row:2;display:grid;grid-template-columns:auto minmax(180px,1fr);gap:14px;align-items:center;padding:8px 10px;border-top:1px solid #e4eaf0;background:#fbfdff}
      [data-hfd] .hfd__image-adjustments[hidden]{display:none!important}
      [data-hfd] .hfd__fit-control,[data-hfd] .hfd__scale-control{display:flex;align-items:center;gap:7px;color:#33445d;font-size:1.2rem;font-weight:700;min-width:0}
      [data-hfd] .hfd__fit-control{white-space:nowrap}
      [data-hfd] .hfd__fit-control input{width:17px;height:17px;margin:0;accent-color:#087df5}
      [data-hfd] .hfd__scale-control input[type="range"]{flex:1;min-width:90px;accent-color:#087df5}
      [data-hfd] .hfd__scale-value{width:46px;text-align:right;font-variant-numeric:tabular-nums;color:#5d6f84}
      [data-hfd] .hfd__select-row.is-disabled .hfd__focus-cell,[data-hfd] .hfd__select-row.is-disabled .hfd__image-adjustments{opacity:.45;pointer-events:none;background:#f3f5f7}
      [data-hfd] .hfd__flag{touch-action:pan-y;cursor:grab;overscroll-behavior:none}
      [data-hfd] .hfd__layer{touch-action:pan-y;cursor:grab}
      [data-hfd] .hfd__flag.is-panning,[data-hfd] .hfd__flag.is-panning .hfd__layer,[data-hfd] .hfd__layer.is-panning{cursor:grabbing;touch-action:none}
      [data-hfd] .hfd__layer img{user-select:none;-webkit-user-drag:none;pointer-events:none}
      @media(max-width:640px){
        [data-hfd] .hfd__select-row{grid-template-columns:72px minmax(0,1fr) 36px!important;grid-template-rows:44px 56px auto;min-width:0}
        [data-hfd] .hfd__type-select,[data-hfd] [data-selection-type]{grid-column:2;grid-row:1;align-self:center;width:calc(100% - 4px);height:36px;border:1px solid #b9c8d8;border-radius:7px}
        [data-hfd] .hfd__type-select .hfd__search-trigger{height:34px;border-radius:6px;font-weight:600;padding:0 26px 0 8px}
        [data-hfd] .hfd__focus-cell{grid-column:3;grid-row:1;width:36px}
        [data-hfd] .hfd__search-select,[data-hfd] [data-flag-selection],[data-hfd] .hfd__upload-controls{grid-column:1/-1;grid-row:2;align-self:center;width:calc(100% - 16px);height:44px;margin:0 8px;min-width:0;border:1px solid #b9c8d8;border-radius:7px;background:#fff}
        [data-hfd] .hfd__search-trigger{height:42px;border-radius:6px;font-weight:600}
        [data-hfd] .hfd__search-select.is-open{border-color:#087df5;box-shadow:0 0 0 2px rgba(8,125,245,.12)}
        [data-hfd] .hfd__search-menu{left:0;right:0}
        [data-hfd] .hfd__focus-button{width:29px;height:29px}
        [data-hfd] .hfd__image-adjustments{grid-row:3;grid-template-columns:1fr;gap:7px;padding:8px;min-width:0}
        [data-hfd] .hfd__scale-control{width:100%}
      }
    `;
    document.head.appendChild(style);

    const currentSide=()=>root.querySelector('[data-side].is-active')?.dataset.side||'front';
    const sideOf=el=>window.hfdUi?.of(el)||currentSide();
    const ui={};
    ['front','back'].forEach(name=>{
      const pane=window.hfdUi?.pane(root,name);
      ui[name]={
        rows:pane?.rows||[],
        layers:pane?.layers||[],
        types:pane?.types||[],
        cells:[],
        adjustments:[]
      };
    });
    const rows=ui.front.rows;
    const layers=[...ui.front.layers,...ui.back.layers];
    const typeSelects=[...ui.front.types,...ui.back.types];
    const blankPan=()=>Array.from({length:4},()=>({x:0,y:0}));
    const state={front:[1,1,1,1],back:[1,1,1,1]};
    const fitState={front:[false,false,false,false],back:[false,false,false,false]};
    const scaleState={front:[100,100,100,100],back:[100,100,100,100]};
    const offsetState={front:blankPan(),back:blankPan()};
    const restoredPres={front:[null,null,null,null],back:[null,null,null,null]};
    const boundsCache=new Map();
    const EDGE_OVERSCAN=1.015;
    const log=(event,data={})=>console.log(`[2in1flags][focus] ${event}`,data);
    let gesture=null;
    let gestureHoldTimer=0;
    let wheelPrintTimer=0;
    let broadcastFrame=0;
    const PAN_HOLD_MS=500;
    const PAN_SCROLL_SLOP=12;

    const countFor=name=>+(window.hfdUi?.pane(root,name)?.counts?.find(b=>b.classList.contains('is-active'))?.dataset.count||root.querySelector('[data-count].is-active')?.dataset.count||1);
    const crossFor=name=>window.hfdUi?.pane(root,name)?.crosses?.find(b=>b.classList.contains('is-active'))?.dataset.cross||root.querySelector('[data-cross].is-active')?.dataset.cross||'single';
    const currentCount=()=>countFor(currentSide());
    const currentCross=()=>crossFor(currentSide());
    const currentSplit=()=>'line';
    const isDiagonal=cross=>cross==='diag-left'||cross==='diag-right';
    const centerValue=cross=>isDiagonal(cross)?4:1;
    const focusSteps=cross=>isDiagonal(cross)?9:3;
    const clampScale=value=>Math.max(50,Math.min(200,Math.round((Number(value)||100)/5)*5));

    function axisForCross(cross){
      if(['horizontal','t-top','t-bottom'].includes(cross))return 'vertical';
      if(['vertical','t-left','t-right'].includes(cross))return 'horizontal';
      if(cross==='quadrant')return 'both';
      if(isDiagonal(cross))return 'diagonal';
      return 'vertical';
    }

    function labelFor(axis,value){
      if(axis==='diagonal')return ['Top left','Top center','Top right','Middle left','Center','Middle right','Bottom left','Bottom center','Bottom right'][value]||'Center';
      if(axis==='vertical')return ['Top','Middle','Bottom'][value]||'Middle';
      if(axis==='horizontal')return ['Left','Center','Right'][value]||'Center';
      if(axis==='both')return ['Top left','Center','Bottom right'][value]||'Center';
      return 'Center';
    }

    function pointFor(axis,value){
      if(axis==='diagonal'){
        const col=value%3,row=Math.floor(value/3);
        return [[7,12,17][col]??12,[7,12,17][row]??12];
      }
      const p=[7,12,17][value]??12;
      if(axis==='vertical')return [12,p];
      if(axis==='horizontal')return [p,12];
      return [p,p];
    }

    function icon(axis,value){
      const [cx,cy]=pointFor(axis,value);
      return `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V5a1 1 0 0 1 1-1h4M15 4h4a1 1 0 0 1 1 1v4M20 15v4a1 1 0 0 1-1 1h-4M9 20H5a1 1 0 0 1-1-1v-4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><circle cx="${cx}" cy="${cy}" r="2.2" fill="currentColor"/></svg>`;
    }

    function fullBounds(){return {x:0,y:0,w:1,h:1,source:'full'};}

    function visibleBounds(src){
      if(!src)return Promise.resolve(fullBounds());
      if(boundsCache.has(src))return boundsCache.get(src);
      const promise=new Promise(resolve=>{
        const probe=new Image();
        if(!String(src).startsWith('data:'))probe.crossOrigin='anonymous';
        probe.onload=()=>{
          try{
            const max=320;
            const ratio=Math.min(1,max/Math.max(probe.naturalWidth,probe.naturalHeight));
            const w=Math.max(1,Math.round(probe.naturalWidth*ratio));
            const h=Math.max(1,Math.round(probe.naturalHeight*ratio));
            const canvas=document.createElement('canvas');
            canvas.width=w;canvas.height=h;
            const ctx=canvas.getContext('2d',{willReadFrequently:true});
            ctx.drawImage(probe,0,0,w,h);
            const data=ctx.getImageData(0,0,w,h).data;
            let minX=w,minY=h,maxX=-1,maxY=-1;
            for(let y=0;y<h;y++)for(let x=0;x<w;x++){
              if(data[(y*w+x)*4+3]>12){
                if(x<minX)minX=x;if(x>maxX)maxX=x;
                if(y<minY)minY=y;if(y>maxY)maxY=y;
              }
            }
            if(maxX<minX||maxY<minY){resolve(fullBounds());return;}
            const pad=1;
            minX=Math.max(0,minX-pad);minY=Math.max(0,minY-pad);
            maxX=Math.min(w-1,maxX+pad);maxY=Math.min(h-1,maxY+pad);
            resolve({x:minX/w,y:minY/h,w:(maxX-minX+1)/w,h:(maxY-minY+1)/h,source:'alpha'});
          }catch(err){
            log('bounds-fallback',{src,error:String(err)});
            resolve(fullBounds());
          }
        };
        probe.onerror=()=>resolve(fullBounds());
        probe.src=src;
      });
      boundsCache.set(src,promise);
      return promise;
    }

    function clipValue(token,size){
      token=token.trim();
      if(token.endsWith('%'))return parseFloat(token)*size/100;
      if(token.endsWith('px'))return parseFloat(token);
      const n=parseFloat(token);
      return Number.isFinite(n)?n:null;
    }

    function sectionBounds(layer,cw,ch){
      const clip=getComputedStyle(layer).clipPath;
      if(!clip||clip==='none')return {x:0,y:0,w:cw,h:ch,clip:'none'};
      const match=clip.match(/^polygon\((.*)\)$/i);
      if(!match)return {x:0,y:0,w:cw,h:ch,clip};
      const points=match[1].split(',').map(point=>{
        const parts=point.trim().split(/\s+/);
        if(parts.length<2)return null;
        const x=clipValue(parts[0],cw),y=clipValue(parts[1],ch);
        return x===null||y===null?null:{x,y};
      }).filter(Boolean);
      if(!points.length)return {x:0,y:0,w:cw,h:ch,clip};
      const xs=points.map(p=>p.x),ys=points.map(p=>p.y);
      const x=Math.max(0,Math.min(...xs));
      const y=Math.max(0,Math.min(...ys));
      const right=Math.min(cw,Math.max(...xs));
      const bottom=Math.min(ch,Math.max(...ys));
      return {x,y,w:Math.max(1,right-x),h:Math.max(1,bottom-y),clip};
    }

    function panVector(cross,value){
      if(isDiagonal(cross)){
        const col=value%3,row=Math.floor(value/3);
        return {x:col===0?1:col===2?-1:0,y:row===0?1:row===2?-1:0};
      }
      if(value===1)return {x:0,y:0};
      const d=value===0?1:-1;
      if(['vertical','t-left','t-right'].includes(cross))return {x:d,y:0};
      if(['horizontal','t-top','t-bottom','single'].includes(cross))return {x:0,y:d};
      return {x:d,y:d};
    }

    function boundsFromImg(img){
      try{return img?.dataset?.visibleBounds?JSON.parse(img.dataset.visibleBounds):null;}catch(_){return null;}
    }

    function computeLayout(img,layer,bounds,cross,value,index,sideName,withOffset=true){
      const cw=layer.clientWidth,ch=layer.clientHeight;
      const nw=img.naturalWidth||1,nh=img.naturalHeight||1;
      if(!cw||!ch||!nw||!nh)return null;
      const section=sectionBounds(layer,cw,ch);
      const bx=bounds.x*nw,by=bounds.y*nh;
      const bw=Math.max(1,bounds.w*nw),bh=Math.max(1,bounds.h*nh);
      const fitEntire=!!fitState[sideName][index];
      const userScale=clampScale(scaleState[sideName][index])/100;
      const baseScale=fitEntire?Math.min(section.w/bw,section.h/bh):Math.max(section.w/bw,section.h/bh)*EDGE_OVERSCAN;
      const scale=baseScale*userScale;
      const iw=nw*scale,ih=nh*scale;
      let left=section.x+section.w/2-(bx+bw/2)*scale;
      let top=section.y+section.h/2-(by+bh/2)*scale;
      const visibleLeft=left+bx*scale;
      const visibleTop=top+by*scale;
      const visibleRight=visibleLeft+bw*scale;
      const visibleBottom=visibleTop+bh*scale;
      const v=panVector(cross,value);
      if(v.x>0)left+=section.x-visibleLeft;
      else if(v.x<0)left+=section.x+section.w-visibleRight;
      if(v.y>0)top+=section.y-visibleTop;
      else if(v.y<0)top+=section.y+section.h-visibleBottom;
      if(withOffset){
        const locked=restoredPres[sideName][index];
        if(locked&&Number(locked.w)>0&&Number(locked.h)>0){
          return {
            left:locked.x*cw,
            top:locked.y*ch,
            iw:locked.w*cw,
            ih:locked.h*ch,
            cw,ch,section,fitEntire,
            scalePercent:clampScale(scaleState[sideName][index])
          };
        }
        const pan=offsetState[sideName][index]||{x:0,y:0};
        left+=pan.x*cw;
        top+=pan.y*ch;
      }
      return {left,top,iw,ih,cw,ch,section,fitEntire,scalePercent:clampScale(scaleState[sideName][index])};
    }

    function applyLayout(img,layout){
      if(!img||!layout)return;
      img.style.position='absolute';
      img.style.left=`${layout.left}px`;
      img.style.top=`${layout.top}px`;
      img.style.width=`${layout.iw}px`;
      img.style.height=`${layout.ih}px`;
      img.style.maxWidth='none';
      img.style.maxHeight='none';
      img.style.objectFit='fill';
      img.style.objectPosition='50% 50%';
      img.style.padding='0';
      img.style.background='transparent';
      img.style.transform='none';
      img.style.transformOrigin='50% 50%';
    }

    function imgBox(img,layer){
      const left=parseFloat(img.style.left),top=parseFloat(img.style.top);
      const width=parseFloat(img.style.width),height=parseFloat(img.style.height);
      if(Number.isFinite(left)&&Number.isFinite(top)&&width>0&&height>0)return {left,top,width,height};
      const ir=img.getBoundingClientRect(),lr=layer.getBoundingClientRect();
      return {left:ir.left-lr.left,top:ir.top-lr.top,width:ir.width,height:ir.height};
    }

    function syncScaleUi(name,index){
      const adj=ui[name].adjustments[index];
      if(!adj)return;
      scaleState[name][index]=clampScale(scaleState[name][index]);
      adj.scale.value=String(scaleState[name][index]);
      adj.value.textContent=`${scaleState[name][index]}%`;
      adj.fit.checked=!!fitState[name][index];
    }

    function paintFlag(name,index){
      const layer=ui[name].layers[index];
      const img=layer?.querySelector('img');
      if(!img||!layer)return;
      const bounds=boundsFromImg(img)||fullBounds();
      const layout=computeLayout(img,layer,bounds,crossFor(name),state[name][index],index,name);
      if(!layout)return;
      applyLayout(img,layout);
      syncScaleUi(name,index);
    }

    function captureOffset(name,index){
      const layer=ui[name].layers[index];
      const img=layer?.querySelector('img');
      if(!img||!layer)return;
      const bounds=boundsFromImg(img)||fullBounds();
      const box=imgBox(img,layer);
      const base=computeLayout(img,layer,bounds,crossFor(name),state[name][index],index,name,false);
      if(!base)return;
      offsetState[name][index]={x:(box.left-base.left)/base.cw,y:(box.top-base.top)/base.ch};
    }

    function unlockFit(name,index){
      if(!fitState[name][index])return;
      const layer=ui[name].layers[index];
      const img=layer?.querySelector('img');
      const box=img&&layer?imgBox(img,layer):null;
      fitState[name][index]=false;
      if(!img||!layer||!box){syncScaleUi(name,index);return;}
      const bounds=boundsFromImg(img)||fullBounds();
      offsetState[name][index]={x:0,y:0};
      const cover=computeLayout(img,layer,bounds,crossFor(name),state[name][index],index,name,false);
      if(cover&&cover.iw>0&&box.width>0){
        scaleState[name][index]=clampScale(scaleState[name][index]*box.width/cover.iw);
        const sized=computeLayout(img,layer,bounds,crossFor(name),state[name][index],index,name,false);
        if(sized)offsetState[name][index]={x:(box.left-sized.left)/sized.cw,y:(box.top-sized.top)/sized.ch};
      }
      paintFlag(name,index);
    }

    async function cropImage(img,layer,type,cross,value,index,side){
      if(!img||!layer)return;
      const src=img.currentSrc||img.src;
      if(!src)return;
      const token=src;
      const bounds=await visibleBounds(src);
      if((img.currentSrc||img.src)!==token)return;
      const sideName=side||currentSide();
      img.dataset.visibleBounds=JSON.stringify(bounds);
      if(gesture&&gesture.side===sideName&&gesture.index===index)return;
      const layout=computeLayout(img,layer,bounds,cross,value,index,sideName);
      if(!layout)return;
      applyLayout(img,layout);
      log('crop-applied',{
        flag:index+1,src,bounds,section:layout.section,
        natural:[img.naturalWidth,img.naturalHeight],container:[layout.cw,layout.ch],
        rendered:[+layout.iw.toFixed(2),+layout.ih.toFixed(2)],
        offset:[+layout.left.toFixed(2),+layout.top.toFixed(2)],
        pan:offsetState[sideName][index],
        overscan:layout.fitEntire?1:EDGE_OVERSCAN,cross,focus:value,fitEntire:layout.fitEntire,scalePercent:layout.scalePercent
      });
    }

    function imageSnapshot(index){
      const row=rows[index],layer=layers[index];
      const img=layer?.querySelector('img');
      if(!img)return {index:index+1,missing:true};
      const rect=img.getBoundingClientRect();
      const layerRect=layer.getBoundingClientRect();
      const cs=getComputedStyle(img);
      let visibleBounds=null;
      try{visibleBounds=img.dataset.visibleBounds?JSON.parse(img.dataset.visibleBounds):null;}catch(_){ }
      const side=currentSide();
      return {
        index:index+1,
        type:typeSelects[index]?.value||'',
        selection:row?.querySelector('[data-flag-selection]')?.value||'',
        src:img.currentSrc||img.src,
        naturalWidth:img.naturalWidth,naturalHeight:img.naturalHeight,
        visibleBounds,
        section:sectionBounds(layer,layer.clientWidth,layer.clientHeight),
        renderedWidth:+rect.width.toFixed(2),renderedHeight:+rect.height.toFixed(2),
        layerWidth:+layerRect.width.toFixed(2),layerHeight:+layerRect.height.toFixed(2),
        objectFit:cs.objectFit,objectPosition:cs.objectPosition,transform:cs.transform,
        left:cs.left,top:cs.top,width:cs.width,height:cs.height,
        clipPath:getComputedStyle(layer).clipPath,
        hidden:layer.hidden||false,focusState:state[side][index],fitEntire:fitState[side][index],scalePercent:scaleState[side][index],pan:offsetState[side][index]
      };
    }

    function logState(reason){
      log(`state:${reason}`,{
        side:currentSide(),count:currentCount(),cross:currentCross(),split:currentSplit(),
        focusState:JSON.parse(JSON.stringify(state)),
        fitState:JSON.parse(JSON.stringify(fitState)),
        scaleState:JSON.parse(JSON.stringify(scaleState)),
        offsetState:JSON.parse(JSON.stringify(offsetState)),
        flags:rows.map((_,i)=>imageSnapshot(i))
      });
    }

    ['front','back'].forEach(name=>{
      ui[name].rows.forEach((row,index)=>{
      row.querySelector('.hfd__focus-cell')?.remove();
      row.querySelector('.hfd__image-adjustments')?.remove();

      const cell=document.createElement('span');
      cell.className='hfd__focus-cell';
      const button=document.createElement('button');
      button.type='button';button.className='hfd__focus-button';button.dataset.focusIndex=String(index);
      cell.appendChild(button);row.appendChild(cell);ui[name].cells[index]={cell,button};

      const adjust=document.createElement('div');
      adjust.className='hfd__image-adjustments';
      adjust.innerHTML=`<label class="hfd__fit-control"><input type="checkbox" data-fit-entire="${index}"><span>Fit Entire Design</span></label><label class="hfd__scale-control"><span>Scale</span><input type="range" min="50" max="200" step="5" value="100" data-image-scale="${index}" aria-label="Flag ${index+1} scale"><output class="hfd__scale-value" data-scale-value="${index}">100%</output></label>`;
      row.appendChild(adjust);
      ui[name].adjustments[index]={
        wrap:adjust,
        fit:adjust.querySelector('[data-fit-entire]'),
        scale:adjust.querySelector('[data-image-scale]'),
        value:adjust.querySelector('[data-scale-value]')
      };

      button.addEventListener('click',e=>{
        e.stopPropagation();
        const cross=crossFor(name);
        const before=state[name][index];
        state[name][index]=(before+1)%focusSteps(cross);
        offsetState[name][index]={x:0,y:0};
        restoredPres[name][index]=null;
        log('focus-click',{flag:index+1,side:name,before,after:state[name][index],count:countFor(name),cross,split:currentSplit()});
        apply();broadcast(true);requestAnimationFrame(()=>logState(`focus-${index+1}`));
      });

      ui[name].adjustments[index].fit.addEventListener('change',e=>{
        fitState[name][index]=!!e.target.checked;
        offsetState[name][index]={x:0,y:0};
        restoredPres[name][index]=null;
        log('fit-change',{flag:index+1,side:name,fitEntire:fitState[name][index]});
        apply();broadcast(true);
      });

      ui[name].adjustments[index].scale.addEventListener('input',e=>{
        restoredPres[name][index]=null;
        scaleState[name][index]=clampScale(e.target.value);
        ui[name].adjustments[index].value.textContent=`${scaleState[name][index]}%`;
        apply();broadcast(true);
      });
      });
    });

    function apply(){
      ['front','back'].forEach(name=>{
      const count=countFor(name),cross=crossFor(name),axis=axisForCross(cross);
      ui[name].rows.forEach((row,index)=>{
        const active=index<count;
        const type=ui[name].types[index]?.value||'country';
        const focusEnabled=active&&type!=='text';
        let value=state[name][index];
        if(value===undefined)value=centerValue(cross);
        if(isDiagonal(cross)&&value<0)value=4;
        if(!isDiagonal(cross)&&value>2)value=1;
        state[name][index]=value;
        scaleState[name][index]=clampScale(scaleState[name][index]);
        const label=labelFor(axis,value);
        const cell=ui[name].cells[index];
        const adj=ui[name].adjustments[index];
        if(!cell||!adj)return;
        cell.cell.hidden=!focusEnabled;
        cell.button.innerHTML=icon(axis,value);
        cell.button.title=`Focus: ${label}`;
        cell.button.setAttribute('aria-label',`Flag ${index+1} focus: ${label}. Click to change.`);
        adj.wrap.hidden=!focusEnabled;
        adj.fit.checked=!!fitState[name][index];
        adj.scale.value=String(scaleState[name][index]);
        adj.value.textContent=`${scaleState[name][index]}%`;
        const img=ui[name].layers[index]?.querySelector('img');
        if(img)cropImage(img,ui[name].layers[index],type,cross,focusEnabled?value:centerValue(cross),index,name);
      });
      });
    }

    function schedule(reason='scheduled'){
      if(gesture)return;
      requestAnimationFrame(()=>requestAnimationFrame(()=>{apply();logState(reason);}));
    }
    function broadcast(print){
      document.dispatchEvent(new CustomEvent('flag:focus-state',{detail:JSON.parse(JSON.stringify(state))}));
      document.dispatchEvent(new CustomEvent('flag:image-adjust-state',{detail:{fit:JSON.parse(JSON.stringify(fitState)),scale:JSON.parse(JSON.stringify(scaleState)),print:!!print}}));
    }
    function liveBroadcast(){
      if(broadcastFrame)return;
      broadcastFrame=requestAnimationFrame(()=>{
        broadcastFrame=0;
        document.dispatchEvent(new CustomEvent('flag:image-adjust-state',{detail:{fit:JSON.parse(JSON.stringify(fitState)),scale:JSON.parse(JSON.stringify(scaleState)),print:false}}));
      });
    }

    function inMotion(){
      return !!root.querySelector('[data-mode="motion"].is-active')||!!root.querySelector('.hfd__flag.hfd-motion-hidden');
    }

    function clipPolygonPoints(layer){
      const rect=layer.getBoundingClientRect();
      const clip=getComputedStyle(layer).clipPath;
      if(!clip||clip==='none')return [{x:rect.left,y:rect.top},{x:rect.right,y:rect.top},{x:rect.right,y:rect.bottom},{x:rect.left,y:rect.bottom}];
      const match=clip.match(/^polygon\((.*)\)$/i);
      if(!match)return [{x:rect.left,y:rect.top},{x:rect.right,y:rect.top},{x:rect.right,y:rect.bottom},{x:rect.left,y:rect.bottom}];
      const points=match[1].split(',').map(point=>{
        const parts=point.trim().split(/\s+/);
        if(parts.length<2)return null;
        const x=clipValue(parts[0],rect.width),y=clipValue(parts[1],rect.height);
        return x===null||y===null?null:{x:rect.left+x,y:rect.top+y};
      }).filter(Boolean);
      return points.length?points:[{x:rect.left,y:rect.top},{x:rect.right,y:rect.top},{x:rect.right,y:rect.bottom},{x:rect.left,y:rect.bottom}];
    }

    function pointInPoly(x,y,pts){
      let inside=false;
      for(let i=0,j=pts.length-1;i<pts.length;j=i++){
        const xi=pts[i].x,yi=pts[i].y,xj=pts[j].x,yj=pts[j].y;
        if(((yi>y)!==(yj>y))&&(x<(xj-xi)*(y-yi)/((yj-yi)||1e-6)+xi))inside=!inside;
      }
      return inside;
    }

    function hitIndex(clientX,clientY){
      if(inMotion())return -1;
      const name=currentSide();
      const count=countFor(name);
      for(let i=0;i<count;i++){
        const layer=ui[name].layers[i];
        if(!layer||layer.hidden)continue;
        if(pointInPoly(clientX,clientY,clipPolygonPoints(layer)))return i;
      }
      return -1;
    }

    function pointerList(map){return [...map.values()];}
    function pointerDist(a,b){return Math.hypot(a.x-b.x,a.y-b.y);}
    function pointerMid(a,b){return {x:(a.x+b.x)/2,y:(a.y+b.y)/2};}

    function bakePanFromPresentation(name,index){
      if(!restoredPres[name]?.[index])return;
      captureOffset(name,index);
      restoredPres[name][index]=null;
    }

    function rememberGestureVisual(){
      if(!gesture)return;
      const layer=ui[gesture.side].layers[gesture.index];
      const img=layer?.querySelector('img');
      if(!img||!layer)return;
      const box=imgBox(img,layer);
      gesture.startLeft=box.left;
      gesture.startTop=box.top;
      gesture.startW=box.width;
      gesture.startH=box.height;
      gesture.startScale=scaleState[gesture.side][gesture.index];
      const pts=pointerList(gesture.pointers);
      if(pts.length>=2){
        gesture.startDist=pointerDist(pts[0],pts[1])||1;
        gesture.origin=pointerMid(pts[0],pts[1]);
      }else if(pts[0]){
        gesture.origin=pts[0];
        gesture.startX=pts[0].x;
        gesture.startY=pts[0].y;
      }
    }

    function clearGestureHold(){
      clearTimeout(gestureHoldTimer);
      gestureHoldTimer=0;
    }

    function gestureFlag(){
      return ui[gesture?.side]?.layers[gesture.index]?.closest('.hfd__flag')||null;
    }

    function armGesture(flag){
      if(!gesture||gesture.armed)return;
      bakePanFromPresentation(gesture.side,gesture.index);
      gesture.armed=true;
      clearGestureHold();
      const liveFlag=flag||gestureFlag();
      liveFlag?.classList.add('is-panning');
      ui[gesture.side].layers[gesture.index]?.classList.add('is-panning');
      rememberGestureVisual();
      if(!liveFlag)return;
      [...gesture.pointers.keys()].forEach(id=>{
        try{liveFlag.setPointerCapture(id);}catch(_){}
      });
    }

    function applyPanFromPointers(){
      if(!gesture)return;
      const pts=pointerList(gesture.pointers);
      const layer=ui[gesture.side].layers[gesture.index];
      const img=layer?.querySelector('img');
      if(!img||!layer||!pts.length)return;
      if(pts.length>=2){
        armGesture(layer.closest('.hfd__flag'));
        unlockFit(gesture.side,gesture.index);
        if(!gesture.pinching){
          gesture.pinching=true;
          gesture.moved=true;
          rememberGestureVisual();
        }
        const dist=pointerDist(pts[0],pts[1])||1;
        const origin=pointerMid(pts[0],pts[1]);
        const next=clampScale(gesture.startScale*(dist/gesture.startDist));
        zoomAround(gesture.side,gesture.index,next,origin.x,origin.y);
        gesture.moved=true;
        return;
      }
      if(!gesture.armed){
        const dx=pts[0].x-gesture.startX,dy=pts[0].y-gesture.startY;
        const drift=Math.hypot(dx,dy);
        if(drift<PAN_SCROLL_SLOP)return;
        if(Math.abs(dy)>Math.abs(dx)*1.2){endGesture(false);return;}
        armGesture(gestureFlag());
        if(!gesture?.armed)return;
      }
      if(gesture.pinching){
        gesture.pinching=false;
        rememberGestureVisual();
      }
      const dx=pts[0].x-gesture.startX,dy=pts[0].y-gesture.startY;
      if(!gesture.moved&&Math.hypot(dx,dy)<3)return;
      if(!gesture.moved){
        gesture.moved=true;
        unlockFit(gesture.side,gesture.index);
        rememberGestureVisual();
      }
      img.style.left=`${gesture.startLeft+(pts[0].x-gesture.startX)}px`;
      img.style.top=`${gesture.startTop+(pts[0].y-gesture.startY)}px`;
      captureOffset(gesture.side,gesture.index);
    }

    function zoomAround(name,index,nextScale,clientX,clientY){
      const layer=ui[name].layers[index];
      const img=layer?.querySelector('img');
      if(!img||!layer)return;
      const prev=clampScale(scaleState[name][index]);
      nextScale=clampScale(nextScale);
      if(nextScale===prev&&!gesture)return;
      const box=gesture&&gesture.pinching?{left:gesture.startLeft,top:gesture.startTop,width:gesture.startW,height:gesture.startH}:imgBox(img,layer);
      const ratio=(gesture&&gesture.pinching?nextScale/gesture.startScale:nextScale/prev)||1;
      const rect=layer.getBoundingClientRect();
      const ox=clientX-rect.left,oy=clientY-rect.top;
      const left=ox-(ox-box.left)*ratio;
      const top=oy-(oy-box.top)*ratio;
      scaleState[name][index]=nextScale;
      img.style.left=`${left}px`;
      img.style.top=`${top}px`;
      img.style.width=`${box.width*ratio}px`;
      img.style.height=`${box.height*ratio}px`;
      captureOffset(name,index);
      syncScaleUi(name,index);
    }

    function endGesture(print){
      if(!gesture)return;
      clearGestureHold();
      const flag=ui[gesture.side].layers[gesture.index]?.closest('.hfd__flag');
      flag?.classList.remove('is-panning');
      ui[gesture.side].layers[gesture.index]?.classList.remove('is-panning');
      if(gesture.moved){
        captureOffset(gesture.side,gesture.index);
        paintFlag(gesture.side,gesture.index);
        broadcast(!!print);
        log('preview-adjust',{flag:gesture.index+1,side:gesture.side,scale:scaleState[gesture.side][gesture.index],pan:offsetState[gesture.side][gesture.index],fitEntire:fitState[gesture.side][gesture.index]});
      }
      gesture=null;
    }

    function onPreviewPointerDown(e){
      if(e.button>0||e.target.closest('[data-drag-zone]'))return;
      const flag=e.target.closest('.hfd__flag');
      if(!flag||!root.contains(flag)||inMotion())return;
      if(gesture){
        e.preventDefault();
        try{flag.setPointerCapture(e.pointerId);}catch(_){}
        gesture.pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
        armGesture(flag);
        rememberGestureVisual();
        return;
      }
      const index=hitIndex(e.clientX,e.clientY);
      if(index<0)return;
      const name=currentSide();
      if(ui[name].types[index]?.value==='text')return;
      const needsHold=e.pointerType==='touch';
      gesture={side:name,index,pointers:new Map([[e.pointerId,{x:e.clientX,y:e.clientY}]]),moved:false,pinching:false,armed:!needsHold,startX:e.clientX,startY:e.clientY,startDist:1,startScale:scaleState[name][index],startLeft:0,startTop:0,startW:0,startH:0,origin:{x:e.clientX,y:e.clientY}};
      rememberGestureVisual();
      bakePanFromPresentation(name,index);
      if(!needsHold){
        e.preventDefault();
        try{flag.setPointerCapture(e.pointerId);}catch(_){}
        flag.classList.add('is-panning');
        ui[name].layers[index]?.classList.add('is-panning');
        return;
      }
      clearGestureHold();
      gestureHoldTimer=setTimeout(()=>armGesture(flag),PAN_HOLD_MS);
    }

    function onPreviewPointerMove(e){
      if(!gesture||!gesture.pointers.has(e.pointerId))return;
      gesture.pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
      if(gesture.armed)e.preventDefault();
      applyPanFromPointers();
      if(gesture?.moved)liveBroadcast();
    }

    function onPreviewPointerUp(e){
      if(!gesture||!gesture.pointers.has(e.pointerId))return;
      gesture.pointers.delete(e.pointerId);
      if(!gesture.pointers.size)endGesture(true);
      else rememberGestureVisual();
    }

    function onPreviewWheel(e){
      if(!(e.ctrlKey||e.metaKey)||inMotion()||gesture)return;
      const flag=e.target.closest?.('.hfd__flag');
      if(!flag||!root.contains(flag))return;
      const index=hitIndex(e.clientX,e.clientY);
      if(index<0)return;
      const name=currentSide();
      if(ui[name].types[index]?.value==='text')return;
      e.preventDefault();
      unlockFit(name,index);
      const factor=e.deltaY<0?1.05:e.deltaY>0?1/1.05:1;
      zoomAround(name,index,scaleState[name][index]*factor,e.clientX,e.clientY);
      paintFlag(name,index);
      liveBroadcast();
      clearTimeout(wheelPrintTimer);
      wheelPrintTimer=setTimeout(()=>broadcast(true),180);
    }

    root.addEventListener('pointerdown',onPreviewPointerDown);
    window.addEventListener('pointermove',onPreviewPointerMove,{passive:false});
    window.addEventListener('pointerup',onPreviewPointerUp);
    window.addEventListener('pointercancel',onPreviewPointerUp);
    root.addEventListener('lostpointercapture',e=>{
      if(!gesture||!gesture.armed||!gesture.pointers.has(e.pointerId))return;
      try{gestureFlag()?.setPointerCapture(e.pointerId);}catch(_){}
    });
    root.addEventListener('wheel',onPreviewWheel,{passive:false});

    root.addEventListener('click',e=>{
      const control=e.target.closest?.('[data-side],[data-count],[data-cross],[data-mode],[data-reset-side]');
      if(!control)return;
      const side=sideOf(control);
      const reset=control.matches('[data-reset-side]')?control:null;
      if(reset){
        const resetSide=reset.dataset.resetSide;
        state[resetSide]=[1,1,1,1];
        fitState[resetSide]=[false,false,false,false];
        scaleState[resetSide]=[100,100,100,100];
        offsetState[resetSide]=blankPan();
        restoredPres[resetSide]=[null,null,null,null];
      }
      if(control.matches('[data-count]')){
        state[side]=[1,1,1,1];
        offsetState[side]=blankPan();
        restoredPres[side]=[null,null,null,null];
      }
      if(control.matches('[data-cross]')){
        const nextCross=control.dataset.cross||'single';
        const center=centerValue(nextCross);
        state[side]=[center,center,center,center];
        offsetState[side]=blankPan();
        restoredPres[side]=[null,null,null,null];
      }
      if(control.matches('[data-side],[data-mode]')&&!reset)return;
      log('control-click',{tag:control.tagName,text:(control.textContent||'').trim(),side:control.dataset.side,count:control.dataset.count,cross:control.dataset.cross,split:control.dataset.split,mode:control.dataset.mode,resetSide:control.dataset.resetSide});
      schedule(control.matches('[data-count],[data-cross]')?'geometry-reset':'control-click');
      if(reset||control.matches('[data-count],[data-cross]'))setTimeout(broadcast,0);
    });

    root.addEventListener('change',e=>{
      if(window.__hfdRestoring)return;
      const control=e.target.closest?.('[data-selection-type],[data-flag-selection]');
      if(!control)return;
      const row=control.closest('[data-select-row]');
      const name=sideOf(control);
      const index=ui[name]?.rows?.indexOf(row)??-1;
      if(index>=0){
        offsetState[name][index]={x:0,y:0};
        restoredPres[name][index]=null;
      }
      log('selection-change',{flag:index+1,control:control.matches('[data-selection-type]')?'type':'selection',value:control.value,side:name,count:countFor(name),cross:crossFor(name)});
      schedule('selection-change');
    });

    document.addEventListener('flag:sides-swapped',()=>{
      const nextFocus=state.front,nextFit=fitState.front,nextScale=scaleState.front,nextOffset=offsetState.front,nextPres=restoredPres.front;
      state.front=state.back;state.back=nextFocus;
      fitState.front=fitState.back;fitState.back=nextFit;
      scaleState.front=scaleState.back;scaleState.back=nextScale;
      offsetState.front=offsetState.back;offsetState.back=nextOffset;
      restoredPres.front=restoredPres.back;restoredPres.back=nextPres;
      schedule('sides-swapped');
      setTimeout(broadcast,0);
    });
    document.addEventListener('flag:design-change',()=>{if(window.__hfdRestoring)return;schedule('design-change');});
    document.addEventListener('flag:upload-state',()=>{if(window.__hfdRestoring)return;schedule('upload-state');});
    document.addEventListener('flag:library-rendered',()=>{if(window.__hfdRestoring)return;schedule('library-rendered');});
    document.addEventListener('flag:restore-adjust',e=>{
      const detail=e.detail||{};
      if(detail.focus?.front&&detail.focus?.back)Object.assign(state,JSON.parse(JSON.stringify(detail.focus)));
      if(detail.fit?.front&&detail.fit?.back)Object.assign(fitState,JSON.parse(JSON.stringify(detail.fit)));
      if(detail.scale?.front&&detail.scale?.back)Object.assign(scaleState,JSON.parse(JSON.stringify(detail.scale)));
      offsetState.front=blankPan();offsetState.back=blankPan();
      restoredPres.front=[null,null,null,null];restoredPres.back=[null,null,null,null];
      if(detail.presentation?.front&&detail.presentation?.back){
        restoredPres.front=detail.presentation.front.slice();
        restoredPres.back=detail.presentation.back.slice();
      }
      ['front','back'].forEach(name=>{
        (detail.visibleBounds?.[name]||[]).forEach((bounds,index)=>{
          if(!bounds||Number(bounds.w)<=0)return;
          const img=ui[name].layers[index]?.querySelector('img');
          if(img)img.dataset.visibleBounds=JSON.stringify(bounds);
        });
      });
      apply();broadcast();
    });

    layers.forEach((layer,index)=>{
      const img=layer.querySelector('img');
      if(!img)return;
      img.addEventListener('load',()=>requestAnimationFrame(()=>{if(gesture)return;apply();log('image-load',imageSnapshot(index));}));
    });

    window.twoInOneFlagDebug={state:()=>logState('manual'),flag:index=>imageSnapshot(Math.max(0,(+index||1)-1))};
    setTimeout(()=>{apply();logState('init');broadcast();},0);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFocus,{once:true});else initFocus();
})();
